import PluginRegistry from './PluginRegistry';
import root from 'window-or-global';

/**
 * Init method for singleton pattern PluginProvider.
 * @returns {PluginRegistry}
 */
const initRegistry = () => {
    const registry = new PluginRegistry();
    root['__epic-diesel-plugin-provider'] = registry;
    return registry;
};

const pluginRegistry =
    typeof root['__epic-diesel-plugin-provider'] !== 'undefined'
        ? root['__epic-diesel-plugin-provider']
        : initRegistry();

export default pluginRegistry;
